/* SOWTH theme behaviour. Mobile nav, gallery, message selector, base selector, cart. */
(function () {
  'use strict';

  /* ---------- mobile navigation ---------- */
  var hdr = document.querySelector('[data-hdr]');
  var burger = document.querySelector('[data-burger]');
  if (hdr && burger) {
    burger.addEventListener('click', function () {
      var open = hdr.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- product configurator ---------- */
  var root = document.querySelector('[data-keepsake]');
  if (!root) return;

  var DATA = {};
  try { DATA = JSON.parse(document.getElementById('sowth-data').textContent); } catch (e) { return; }

  var MESSAGES = DATA.messages || [];
  var BASES = DATA.bases || [];
  if (!MESSAGES.length) return;

  var cur = DATA.initial || 0;
  if (cur < 0 || cur >= MESSAGES.length) cur = 0;
  var base = 0;
  var initialVariant=(MESSAGES[cur].variants||[]).find(function(v){return String(v.id)===String(DATA.initialVariant);});
  if(initialVariant && /battery/i.test(initialVariant.title)) base=1;

  /* ---------- gallery ---------- */
  var gmain = root.querySelector('[data-gmain]');
  var thumbs = root.querySelectorAll('[data-th]');
  var slides = root.querySelectorAll('[data-slide]');
  var swipe = root.querySelector('[data-swipe]');
  var dots = root.querySelectorAll('[data-dot]');
  var shot = 0;

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function shotOf(url, alt, w) {
    return '<img src="' + esc(url) + '" alt="' + esc(alt) +
      '" width="' + w + '" height="' + w + '" loading="eager" decoding="async">';
  }
  function altFor(m, url) {
    if (String(url || '').indexOf('-battery-message-v1') !== -1) return 'Your selected message, shown straight-on. Battery base with front lighting-control button.';
    if (String(url || '').indexOf('set-wireless-room') !== -1) return 'Illustrative wireless set, softly lit. Chain rests in the two acrylic notches; front button shown. Message omitted. Actual glow varies with room lighting.';
    if (String(url || '').indexOf('set-wired-room') !== -1) return 'Illustrative wired set, softly lit. Chain rests in the two acrylic notches; white cable shown. Message omitted. Actual glow varies with room lighting.';
    if (String(url || '').indexOf('wireless-button') !== -1) return 'Wireless base with its front lighting-control button. Supplier-based illustration, shown unlit with the message omitted.';
    if (String(url || '').indexOf('necklace-in-hand') !== -1) return 'Illustrative in-hand view. Pendant measures 15.7 × 15.7 mm.';
    if (String(url || '').indexOf('set-supplier-form') !== -1) return 'Supplier-based retouched view: corded base, shown unlit. Message omitted to show the acrylic and necklace slots.';
    if (String(url || '').indexOf('necklace-lifestyle') !== -1) return 'Illustrative worn view. Pendant measures 15.7 mm; fit varies with chain length.';
    if (String(url || '').indexOf('set-lifestyle') !== -1) return 'The set at home, with the message omitted. Corded base shown; styling props are not included.';
    if (String(url || '').indexOf('pendant-detail') !== -1) return 'Close-up of the Love Knot pendant and setting.';
    if (String(url || '').indexOf('sowth-light-') !== -1) return 'Your selected message, shown straight-on without the necklace. Corded base shown.';
    if (String(url || '').indexOf('sowth-keepsake-light-base-detail') !== -1) {
      return 'Wooden LED base detail for the Keepsake Set.';
    }
    return 'Your selected message, shown straight-on. Corded base shown.';
  }

  /* Each message is its own product with its own photographs, one set per LED
     base, so the gallery is rebuilt whenever either choice changes. */
  function shotsFor(m, bi) {
    var g = m && m.images;
    if (!g || !g.length) return [];
    return (g[bi] && g[bi].length) ? g[bi] : (g[0] || []);
  }

  function paintGallery() {
    var m = MESSAGES[cur] || {};
    var imgs = shotsFor(m, base);
    var included = document.querySelector('[data-included-photo]');
    if (included) {
      var includedImage = included.querySelector('img');
      var includedUrl = base === 1 ? included.dataset.batterySrc : included.dataset.cordedSrc;
      if (includedImage && includedUrl) {
        includedImage.removeAttribute('srcset');
        includedImage.src = includedUrl;
        includedImage.alt = 'Love Knot necklace, acrylic with two chain notches, and ' + (base === 1 ? 'battery base with front control button.' : 'corded base with USB cable.');
      }
      var includedLabel = included.querySelector('[data-included-base]');
      if (includedLabel) includedLabel.textContent = base === 1 ? 'Battery' : 'Corded';
    }

    if (imgs.length) {
      if (shot >= imgs.length) shot = 0;
      var note = root.querySelector('[data-base-photo-note]');
      if (note) note.hidden = base !== 1;
      var alt = altFor(m, imgs[shot]);
      var caption = root.querySelector('[data-set-caption]');
      if(caption){caption.textContent=alt;caption.hidden=false;}
      if (gmain) gmain.innerHTML = shotOf(imgs[shot], alt, 1000);
      Array.prototype.forEach.call(thumbs, function (t, i) {
        t.hidden = i >= imgs.length;
        if (i < imgs.length) t.innerHTML = shotOf(imgs[i], altFor(m, imgs[i]), 110);
        t.setAttribute('aria-pressed', i === shot);
      });
      Array.prototype.forEach.call(slides, function (s, i) {
        s.hidden = i >= imgs.length;
        if (i < imgs.length) s.innerHTML = shotOf(imgs[i], altFor(m, imgs[i]), 1000);
      });
      Array.prototype.forEach.call(dots, function (d, i) {
        d.hidden = i >= imgs.length;
        d.classList.toggle('on', i === shot);
      });
      return;
    }

    if (gmain && slides[shot]) gmain.innerHTML = slides[shot].innerHTML;
    Array.prototype.forEach.call(thumbs, function (t, i) { t.setAttribute('aria-pressed', i === shot); });
    Array.prototype.forEach.call(dots, function (d, i) { d.classList.toggle('on', i === shot); });
  }
  Array.prototype.forEach.call(thumbs, function (t, i) {
    t.addEventListener('click', function () { shot = i; paintGallery(); });
  });
  if (swipe) {
    swipe.addEventListener('scroll', function () {
      var i = Math.round(swipe.scrollLeft / swipe.clientWidth);
      if (i !== shot) { shot = i; paintGallery(); }
    }, { passive: true });
  }

  /* ---------- variant resolution ---------- */
  function variantFor(mi, bi) {
    var m = MESSAGES[mi], b = BASES[bi];
    if (!m.variants || !m.variants.length) return null;
    var needle = String(b.match || b.label).toLowerCase();
    for (var i = 0; i < m.variants.length; i++) {
      if (String(m.variants[i].title).toLowerCase().indexOf(needle) !== -1) return m.variants[i];
    }
    return m.variants.length === 1 ? m.variants[0] : null;
  }

  /* ---------- selectors ---------- */
  var idx = root.querySelectorAll('[data-msg]');
  var comparisons = root.querySelectorAll('[data-message-choice]');
  Array.prototype.forEach.call(comparisons,function(button){button.addEventListener('click',function(){
    selectMessage(Number(button.dataset.messageChoice));
    button.closest('details').open=false;
    root.querySelector('[data-selected-line]').closest('.selm').scrollIntoView({block:'center',behavior:'auto'});
    var selectedButton=idx[Number(button.dataset.messageChoice)];if(selectedButton)selectedButton.focus({preventScroll:true});
  });});
  var counter = root.querySelector('[data-counter]');
  var selLine = root.querySelector('[data-selected-line]');
  var selName = root.querySelector('[data-selected-name]');
  var WORDS = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight',
               'Nine', 'Ten', 'Eleven', 'Twelve'];

  function selectMessage(i) {
    cur = i;
    var m = MESSAGES[i];
    if (counter) counter.textContent = (WORDS[i] || (i + 1)) + ' of ' + MESSAGES.length;
    Array.prototype.forEach.call(idx, function (c, k) { c.setAttribute('aria-pressed', k === i); });
    
    Array.prototype.forEach.call(comparisons,function(button){var selected=Number(button.dataset.messageChoice)===i;button.setAttribute('aria-pressed',String(selected));button.querySelector('[data-message-choice-label]').textContent=selected?'Selected':'Choose this message';});
    if (selLine) selLine.textContent = m.line;
    if (selName) selName.textContent = m.label;
    shot = 0;
    if (swipe) swipe.scrollLeft = 0;
    paintGallery();
    hideSaid();
    syncButtons();
  }
  Array.prototype.forEach.call(idx, function (b, i) {
    b.addEventListener('click', function () { selectMessage(i); });
  });

  var bops = root.querySelectorAll('[data-base]');
  Array.prototype.forEach.call(bops, function (b, i) {
    b.addEventListener('click', function () {
        base = i;
        shot = 0;
        if (swipe) swipe.scrollLeft = 0;
      Array.prototype.forEach.call(bops, function (x, k) { x.setAttribute('aria-pressed', k === i); });
      paintGallery();
      hideSaid();
      syncButtons();
    });
  });

  /* ---------- add to cart ---------- */
  var atc = root.querySelector('[data-atc]');
  var satc = document.querySelector('[data-satc]');
  var said = root.querySelector('[data-said]');
  var stickline = document.querySelector('[data-stickline]');
  var cartCounts = document.querySelectorAll('[data-cart-count]');

  function hideSaid() { if (said) said.classList.remove('on'); }

  function syncButtons() {
    var v = variantFor(cur, base);
    var ok = !!(v && v.available);
    [atc, satc].forEach(function (b) {
      if (!b) return;
      b.disabled = !ok;
      if (b === atc) b.textContent = ok ? 'Add to bag, ' + v.price : 'Sold out';
    });
    if(v)root.querySelector('.pz').textContent=v.price;
    Array.prototype.forEach.call(bops,function(b,i){b.setAttribute('aria-pressed',String(i===base));});
    if (stickline) {
      stickline.textContent = (v?v.price:DATA.price) + ', ' + MESSAGES[cur].label + ', ' + BASES[base].label;
    }
  }

  function addToCart() {
    var v = variantFor(cur, base);
    if (!v) return;
    var m = MESSAGES[cur], b = BASES[base];
    [atc, satc].forEach(function (x) { if (x) x.disabled = true; });

    fetch(DATA.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('Cart request failed'); return r.json(); })
      .then(function () { return fetch(DATA.routes.cart + '.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(cartCounts, function (el) { el.textContent = cart.item_count; });
        document.querySelectorAll('.sowth-header__cart').forEach(function(el){el.textContent='Cart ('+cart.item_count+')';el.setAttribute('aria-label','Cart, '+cart.item_count+(cart.item_count===1?' item':' items'));});
        if (said) {
          said.innerHTML = '<b>Added to your bag.</b> ' + m.label + ', "' + m.line +
            '" with the ' + b.label + ' base. <a href="/cart">View your bag</a>';
          said.classList.add('on');
        }
      })
      .catch(function () {
        if (said) {
          said.innerHTML = '<b>Something went wrong.</b> Please try again, or refresh the page.';
          said.classList.add('on');
        }
      })
      .then(function () { syncButtons(); });
  }

  if (atc) atc.addEventListener('click', addToCart);
  if (satc) satc.addEventListener('click', addToCart);

  selectMessage(cur);
})();
